import {Injectable} from '@angular/core';
import {Boundaries, ChartSignalEntry, Colors} from '@models/pages/user-defined-page/chart-signal-entry';
import {Signal} from '@models/dashboard/signal';
import {ChartsHelperService} from '@services/charts/helper/charts-helper.service';

@Injectable({
  providedIn: 'root'
})
export class GaugeChartAxisSettingsGeneratorService {

  constructor(private chartsHelperService: ChartsHelperService) {
  }

  public generateYAxis(gaugeType, firstSignal: ChartSignalEntry, machineSignal: Signal, boundaries: Boundaries, colors: Colors) {

    let YAxis;
    if (gaugeType === 'gauge') {

      YAxis = {
        min: boundaries.min,
        max: boundaries.max,

        minorTickInterval: 'auto',
        minorTickWidth: 1,
        minorTickLength: 10,
        minorTickPosition: 'inside',
        minorTickColor: '#666',

        tickPixelInterval: 30,
        tickWidth: 2,
        tickPosition: 'inside',
        tickLength: 10,
        tickColor: '#666',
        labels: {
          step: 2,
          rotation: 'auto'
        },
        title: {
          text: machineSignal.unit
        },
        plotBands: [{
          from: boundaries.min,
          to: boundaries.area1End,
          color: this.chartsHelperService.createLineHex(colors.area1)
        }, {
          from: boundaries.area1End,
          to: boundaries.area2End,
          color: this.chartsHelperService.createLineHex(colors.area2)
        }, {
          from: boundaries.area2End,
          to: boundaries.max,
          color: this.chartsHelperService.createLineHex(colors.area3)
        }
        ]
      };

      // Solid Gauge Y Axis
    } else {
      YAxis = {
        stops: this.generateStops(firstSignal, boundaries, colors),
        lineWidth: 0,
        minorTickInterval: null,
        tickAmount: 1,
        tickColor: '',
        labels: {
          format: '<div class="solid-gauge-range">{value:.' + machineSignal.decimals + 'f}</div>',
          y: 16
        },
        min: boundaries.min,
        max: boundaries.max,
        tickPositioner: () => {
          return [boundaries.min, boundaries.max];
        },
        title: {
          text: null
        }
      };

    }

    return YAxis;
  }

  private generateStops(firstSignal: ChartSignalEntry, boundaries: Boundaries, colors: Colors) {
    const area1End = this.normalizeValue(boundaries.area1End, boundaries);
    const area2End = this.normalizeValue(boundaries.area2End, boundaries);

    let stops: any[];
    if (firstSignal.transition) {
      const dividend = area1End + area2End;
      const middle = (dividend === 0) ? 0.5 : (dividend / 2);
      stops = [
        [area1End, this.chartsHelperService.createLineHex(colors.area1)],
        [middle, this.chartsHelperService.createLineHex(colors.area2)],
        [area2End, this.chartsHelperService.createLineHex(colors.area3)]
      ];
    } else {
      stops = [
        [area1End, this.chartsHelperService.createLineHex(colors.area1)],
        [area1End + 0.001, this.chartsHelperService.createLineHex(colors.area2)],
        [area2End - 0.001, this.chartsHelperService.createLineHex(colors.area2)],
        [area2End, this.chartsHelperService.createLineHex(colors.area3)]];
    }

    return stops;
  }

  //Method to return a normalized value between 0 and 1
  private normalizeValue(value, boundaries: Boundaries) {
    const x = (value - boundaries.min);
    const y = (boundaries.max - boundaries.min);
    if (x === 0 || y === 0) {
      return 0;
    }
    return x / y;
  }
}
